// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3ge-G","title":"ClientCherryInfo_title__1fm7Y","itemText":"ClientCherryInfo_itemText__3FdZe"};